import { useEffect, useState } from "react";
import { parseUnits } from "ethers/lib/utils";
import { getRelayClient } from "../cross-chain-tx/client";
export const useCurrencyRate = ({ fromValue, fromChain, toChain, walletAddress, fromCurrency, toCurrency, tradeType, insufficientBalance, }) => {
    const [priceValue, setPriceValue] = useState(0);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (!fromChain ||
            !toChain ||
            !walletAddress ||
            !fromValue ||
            !fromCurrency ||
            !toCurrency ||
            !tradeType ||
            fromChain.testnet !== toChain.testnet ||
            insufficientBalance) {
            return;
        }
        const fetchPrice = async () => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            setLoading(true);
            setError("");
            try {
                const relayClient = getRelayClient(fromChain.chainId);
                const decimals = tradeType === "EXACT_INPUT"
                    ? (_a = fromCurrency.decimals) !== null && _a !== void 0 ? _a : 18
                    : (_b = toCurrency.decimals) !== null && _b !== void 0 ? _b : 18;
                const amount = parseUnits(fromValue.toString(), decimals).toString();
                const price = await relayClient.actions.getPrice({
                    user: walletAddress,
                    originChainId: fromChain.chainId,
                    destinationChainId: toChain.chainId,
                    amount,
                    originCurrency: fromCurrency.address,
                    destinationCurrency: toCurrency.address,
                    tradeType,
                });
                if (tradeType === "EXACT_INPUT") {
                    const priceOut = (_d = (_c = price.details) === null || _c === void 0 ? void 0 : _c.currencyOut) === null || _d === void 0 ? void 0 : _d.amountFormatted;
                    if (priceOut)
                        return setPriceValue(parseFloat(priceOut));
                }
                if (tradeType === "EXACT_OUTPUT") {
                    const priceIn = (_f = (_e = price.details) === null || _e === void 0 ? void 0 : _e.currencyIn) === null || _f === void 0 ? void 0 : _f.amountFormatted;
                    if (priceIn)
                        return setPriceValue(parseFloat(priceIn));
                }
                if ((_g = price.errors) === null || _g === void 0 ? void 0 : _g.length) {
                    setError(((_j = (_h = price.steps) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.error) ? (_l = (_k = price.steps) === null || _k === void 0 ? void 0 : _k[0]) === null || _l === void 0 ? void 0 : _l.error : "");
                }
            }
            catch (err) {
                console.log(err);
                setError("Error fetching rate");
            }
            finally {
                setLoading(false);
            }
        };
        fetchPrice();
    }, [
        fromChain,
        toChain,
        walletAddress,
        fromValue,
        fromCurrency,
        toCurrency,
        tradeType,
        insufficientBalance,
    ]);
    return { priceValue, error, loading };
};
